import React, { Component } from 'react';
import { ListLayout } from '../containers/Layout';
import Pagination from '../../../../commonModules/interface/Pagination';
import { isEmpty } from "lodash";
import Select from 'react-select'
import Dialog from '../../../../commonModules/interface/Dialog';
// import PopUp from '../../../../commonModules/interface/PopUp';
import InputText from '../../../../commonModules/interface/form-input-inline';
import FormValidateOrder from './FormValidateOrder';
import EcomSourceBadge from '../containers/EcomSourceBadge';
import { safeEcomOrderUrl } from '../../../../../../../jsx/utils/ecomSale';
import { TableCell, TableRow, TableHead, TableBody, IconButton, AppBar, Tabs, Tab } from '@material-ui/core';
import { AddCircleOutlineRounded } from '@material-ui/icons';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { fetchEcomLinks } from '../../../../../../../jsx/actions/settingsAction';
import { selectEcomActive } from '../../../../../../../jsx/utils/ecomLinks';


const formatNumbers =  new Intl.NumberFormat('fr-FR',{ maximumFractionDigits: 0 })

class ListOrder extends Component {
    state = {
        orderType: "WAITING",
        // Dialog
        singleOrder:{ },

        breadcrumb: "",

        search:"",
        searchClass:"custom-search",
        filteredList:[],
        reload : false,

        selectSearch:"",
        selectSearchDisplay:{
            value:"",
            label:"Tous les Magasins",
        },

        ecomOrders: [],
        ecomLoading: false,
    }

    componentDidMount = () => {
        console.log("MOUNTING ListOrders ");
        this.filterList("")
        // Onglet Prestashop affiché seulement si le compte a une boutique jumelée active.
        this.props.fetchEcomLinks()
    }

    // Onglet affiché : l'onglet Prestashop retiré (aucune boutique active) revient sur « En Attente ».
    currentOrderType() {
        return this.state.orderType === "PRESTASHOP" && !this.props.ecomActive ? "WAITING" : this.state.orderType;
    }
    fetchEcomOrders = async () => {
        this.setState({ ecomLoading: true });
        try {
            const res = await fetch('/orders/ecom', { credentials: 'same-origin' });
            const data = await res.json();
            this.setState({ ecomOrders: Array.isArray(data) ? data : [], ecomLoading: false });
        } catch (e) {
            console.error("Failed to fetch ecom orders:", e);
            this.setState({ ecomLoading: false });
        }
    }

    createEcomOrderList() {
        return this.state.ecomOrders.map(order => (
            <TableRow key={order.id}>
                <TableCell>{order.date ? new Date(order.date).toLocaleString('fr-FR') : '-'}</TableCell>
                <TableCell>{order.client || '-'}</TableCell>
                <TableCell>
                    <EcomSourceBadge source="prestashop" />
                </TableCell>
                <TableCell>
                    {safeEcomOrderUrl(order.order_url) && order.external_ref
                        ? <a href={safeEcomOrderUrl(order.order_url)} target="_blank" rel="noopener noreferrer"
                            title="Ouvrir la commande dans l'administration PrestaShop">{order.external_ref}</a>
                        : (order.external_ref || '-')}
                </TableCell>
                <TableCell>{order.total_ttc ? formatNumbers.format(order.total_ttc) : '-'}</TableCell>
                <TableCell>{order.cancelled ? 'Annulée' : 'Active'}</TableCell>
            </TableRow>
        ));
    }

    createOrderList(){// order list tr
        const { ORDERS } = this.props
        return Object.values(ORDERS[this.currentOrderType()] || {}).map( order => {  
        // return this.props.pageOfItems.map( ID => {  
            console.log('====================================');
            console.log({order});
            console.log('====================================');
            if(order){
                return (        
                    <TableRow key={order.id}>
                        <TableCell>{(new Date(order.date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>{order.shop_app_client}</TableCell>
                        <TableCell>{order.order_status}</TableCell>

                        <TableCell>{formatNumbers.format(order.total_price)}</TableCell>
                        <TableCell>
                            {this.currentOrderType() === "WAITING" &&
                            <IconButton color="secondary" onClick={
                                () => this.handleSingleOrder(order)
                            }>
                                <AddCircleOutlineRounded />
                            </IconButton>

                            }
                        </TableCell>
                                
                        <TableCell>
                            {/* <button className="btn btn-danger" onClick={()=>{
                                this.setState({
                                    toDelete: order,
                                    deletePopUp : 'block'})
                                }}><i className="zmdi zmdi-delete"></i></button> */}
                        </TableCell>
                    </TableRow>
                )
            }          
        })
    }
    handleSingleOrder = (order) => {
        this.setState({
            singleOrder: order,
        })
    }
    createShopList = () => {
        const list = [{value:"", label:"Tous les Magasins"}]
        const { SHOPS} = this.props
        if( SHOPS ){
            Object.values(SHOPS).map( shop => { 
                list.push (       
                    {value:shop.id, label:shop.name} 
                )
            })
        } 
        return list
    }

    normalizeStr = (str) => {// remove accent and lower case str
        str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        return str
    }

    shopFilter(selected){
        const { ORDERS, SHOPS } = this.props
        // let selected = this.state.selectSearch
        
        let filteredShop = Object.keys(ORDERS).filter( ID => {
                return (ORDERS[ID].shop_id === selected)
            }
        )
        console.log({filteredShop});

        return filteredShop
    }
    searchFilter(search, list){
        const { ORDERS } = this.props
        // const { search } = this.state
        console.log({search});
        
        let searching = search ? this.normalizeStr(search) : ""
                        
        let myList = []
        list.map( orderID => {
            if(!!this.hasProduct(ORDERS[orderID], searching)){
                myList.push(orderID)
            }
        })
        console.log('====================================');
        console.log({myList});
        console.log('====================================');
        return list.filter( orderID => ( !!this.hasProduct(ORDERS[orderID], searching) ))
    }
    
    filterList(searchValue, selectedShop){
        let filteredList = selectedShop ? this.shopFilter(selectedShop) : Object.keys(this.props.ORDERS)
        // filteredList = searchValue ? this.searchFilter(searchValue, filteredList) : filteredList

        this.setState({
            filteredList,
            reload:!this.state.reload
        })
    }

    validateStatus = async (order) => {
        console.log('[INFO] validate status orders.jsx');
        await this.props.validateOrder(order)
        
        if(this.props.STATE.orders.error){
            console.log("ERROR", this.props.STATE.orders.error);
            this.setState({
                sending: false,
            })
            toast.error( this.props.STATE.orders.error)
        } else {
            console.log("fetched");
            //success 
            this.setState({
                sending: false,
            })
            toast.info("Commande validée")
            this.handleClose()
            this.clearForms()
        }
    }

    render() {
        const { singleOrder } = this.state;
        const orderType = this.currentOrderType();

        return (
            <React.Fragment>
                {!isEmpty(singleOrder) && 
                    <FormValidateOrder
                        order={singleOrder} 
                        {...this.props}
                        // notif={this.props.notif}
                        handleClosePopUp={() => this.setState({ singleOrder: {}})} 
                    />
                }
                <div>

                    <AppBar position="static">
                        <Tabs
                            value={orderType}
                            onChange={(e, tab) => {
                                this.setState({ orderType: tab });
                                if (tab === "PRESTASHOP") {
                                    this.fetchEcomOrders();
                                }
                            }}
                            indicatorColor="secondary"
                            // textColor="secondary"
                            variant="scrollable"
                            scrollButtons="auto"
                        >
                            <Tab value="WAITING" label="En Attente" />
                            <Tab value="VALIDATE" label="Validé" />
                            <Tab value="SHIPPED" label="Expédié" />
                            <Tab value="DELIVERED" label="Livré" />
                            {this.props.ecomActive && <Tab value="PRESTASHOP" label="Prestashop" />}
                        </Tabs>
                    </AppBar>
                    {orderType === "PRESTASHOP" ? (
                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Source</TableCell>
                                <TableCell>Réf. Prestashop</TableCell>
                                <TableCell>Total TTC</TableCell>
                                <TableCell>Statut</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.ecomLoading &&
                                <TableRow>
                                    <TableCell colSpan="6">
                                        <div className="text-center">Chargement...</div>
                                    </TableCell>
                                </TableRow>
                            }
                            {!this.state.ecomLoading && this.state.ecomOrders.length > 0 && this.createEcomOrderList()}
                            {!this.state.ecomLoading && this.state.ecomOrders.length === 0 &&
                                <TableRow>
                                    <TableCell colSpan="6">
                                        <div className="text-center">Pas de commandes Prestashop</div>
                                    </TableCell>
                                </TableRow>
                            }
                        </TableBody>
                    </ListLayout>
                    ) : (
                    <ListLayout>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date</TableCell>
                                <TableCell>Client</TableCell>
                                <TableCell>Statut</TableCell>
                                <TableCell>Total</TableCell>
                                <TableCell>Détails</TableCell>
                                <TableCell>Options</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {Object.keys(this.props.ORDERS).length > 0 && this.createOrderList() }
                            { Object.keys(this.props.ORDERS).length === 0  &&
                                <TableRow>
                                    <TableCell colSpan="6">
                                    <div className="text-center">
                                        Pas de commandes
                                    </div>
                                </TableCell>
                            </TableRow>
                            }
                        </TableBody>
                    </ListLayout>
                    )}                     
                    {/* <div className="text-center">
                        {this.state.reload &&
                        <Pagination items={this.state.filteredList} onChangePage={this.props.onChangePage} pageSize={15} initialPage={this.props.currentPage} />
                        }
                        {!this.state.reload &&
                        <Pagination items={this.state.filteredList} onChangePage={this.props.onChangePage} pageSize={15} initialPage={this.props.currentPage} />
                        }
                    </div> */}
                </div>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return { ecomActive: selectEcomActive(state) };
}

export default connect(mapStateToProps, { fetchEcomLinks })(ListOrder);